export default {
   "IcoMoonType":"selection",
   "icons":[
      {
         "icon":{
            "paths":[
               "M400.331 2.245c-105.122 20.138-181.616 111.217-181.616 216.485 0 153.324 157.339 260.651 299.792 204.585 70.769-27.919 123.443-92.452 136.499-167.741 19.922-112.819-53.366-223.121-166.273-250.811-20.612-5.035-67.791-6.408-88.403-2.517zM469.496 75.703c41.682 8.696 80.617 38.903 99.397 76.662 28.856 58.584 18.319 124.033-27.028 169.572-57.94 57.668-148.405 57.668-206.577-0.229-57.714-57.211-57.485-148.519 0-206.187 35.728-35.47 84.739-50.117 134.208-39.819z",
               "M286.279 514.166c-70.998 9.155-137.643 42.107-190.089 94.74-38.705 38.446-64.585 80.323-81.303 131.128-13.054 40.274-14.657 54.922-14.887 124.488 0 60.416 0.229 63.616 4.809 69.571 2.519 3.43 7.558 8.463 10.993 10.982 6.184 4.808 8.245 4.808 215.74 5.494 207.266 0.456 209.556 0.456 218.488-4.122 23.818-12.129 26.567-44.851 5.039-61.327l-8.016-6.18-374.911-1.147v-28.145c0-75.745 23.131-135.475 72.142-186.737 28.628-29.747 68.478-54.236 108.099-66.591 32.063-9.841 51.759-11.443 144.055-11.443 86.342 0 87.258 0 97.106-5.263 11.909-6.18 18.322-17.162 18.322-31.35 0-14.193-6.413-25.175-18.322-31.355-9.848-5.262-10.306-5.262-100.541-5.033-49.927 0.231-97.793 1.373-106.725 2.289z",
               "M753.485 514.852c-16.947 7.782-21.755 18.995-21.755 50.115v23.342l-14.889 4.352c-8.243 2.284-22.902 8.238-32.517 13.271l-17.408 8.694-18.78-18.079c-13.972-13.501-21.299-18.765-27.254-19.676-22.446-4.352-44.887 13.957-44.887 36.613 0 11.443 2.744 15.79 22.216 35.697l16.947 17.167-8.934 17.618c-5.038 9.61-10.993 24.028-13.281 32.266l-4.122 14.648-26.798 0.916c-22.902 0.686-27.94 1.372-33.208 5.489-16.717 12.36-21.299 31.124-11.909 48.742 8.018 15.334 16.031 18.54 46.49 18.54h25.196l4.352 14.874c2.289 8.238 8.243 22.886 13.281 32.497l8.934 17.618-16.947 17.167c-19.471 19.907-22.216 24.253-22.216 35.697 0 16.937 13.281 33.638 29.312 36.844 15.119 2.975 23.132-0.686 43.059-19.907l18.55-18.309 17.408 8.924c9.615 5.033 24.274 10.982 32.517 13.271l14.889 4.352v24.714c0 30.894 3.666 39.818 19.466 47.37 17.864 8.694 35.727 4.116 47.867-12.36 4.122-5.263 4.808-10.296 5.494-33.183l0.916-26.772 14.659-4.122c8.243-2.289 22.671-8.238 32.292-13.271l17.408-8.924 18.55 18.309c20.152 19.451 27.484 22.881 44.201 19.676 10.762-2.058 22.216-13.501 26.107-25.856 4.582-15.565 0.23-25.631-19.922-46.454l-17.178-17.393 8.929-17.393c5.043-9.61 10.998-24.028 13.286-32.266l4.122-14.648 26.798-0.916c29.082-0.686 33.894-2.514 44.201-16.476 7.096-9.38 6.641-29.747-0.691-40.044-8.699-12.129-20.383-16.251-47.176-16.251h-22.902l-4.352-14.874c-2.289-8.238-8.243-22.886-13.286-32.497l-8.929-17.393 17.178-17.393c19.922-20.593 24.504-31.119 19.922-46.454-3.661-11.899-12.826-21.284-24.735-24.714-16.486-5.033-24.044-1.833-45.343 18.534l-18.78 18.079-17.408-8.694c-9.62-5.033-24.049-10.988-32.292-13.271l-14.659-4.122-0.916-26.772c-0.686-29.066-2.519-33.869-16.031-43.94-7.788-5.719-25.876-7.323-35.041-2.975zM794.711 661.54c39.393 10.296 69.852 40.96 80.159 80.553 14.884 56.98-21.53 116.936-80.159 132.27-57.487 14.874-117.489-21.509-132.833-80.097-20.383-78.49 54.277-153.093 132.833-132.726z"
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "affiliatemanager"
            ]
         },
         "attrs":[
            {
               "fill":"rgb(68, 56, 249)"
            },
            {
               "fill":"rgb(68, 56, 249)"
            },
            {
               "fill":"rgb(68, 56, 249)"
            }
         ],
         "properties":{
            "order":52,
            "id":0,
            "name":"affiliatemanager",
            "prevSize":32,
            "code":59666
         },
         "setIdx":0,
         "setId":4,
         "iconIdx":0
      },
      {
         "icon":{
            "paths":[
               "M992.128 124.16c5.978 5.998 9.338 14.122 9.338 22.592s-3.36 16.593-9.338 22.592l-66.752 66.816-128-128 66.752-66.816c6.003-5.999 14.138-9.369 22.624-9.369s16.621 3.37 22.624 9.369l82.752 82.816zM880.128 281.344l-128-128-436.032 436.096c-3.523 3.521-6.174 7.817-7.744 12.544l-51.52 154.496c-0.934 2.816-1.067 5.837-0.383 8.723s2.157 5.53 4.256 7.629c2.098 2.099 4.739 3.571 7.626 4.256s5.908 0.55 8.725-0.384l154.496-51.52c4.721-1.549 9.016-4.179 12.544-7.68l436.032-436.16z",
               "M64 864c0 25.459 10.115 49.882 28.118 67.885s42.422 28.115 67.882 28.115h704c25.459 0 49.882-10.112 67.885-28.115s28.115-42.426 28.115-67.885v-384c0-8.487-3.373-16.627-9.37-22.628-6.003-6.001-14.144-9.372-22.63-9.372s-16.627 3.372-22.63 9.372c-5.997 6.001-9.37 14.141-9.37 22.628v384c0 8.486-3.373 16.627-9.37 22.624-6.003 6.003-14.144 9.376-22.63 9.376h-704c-8.487 0-16.627-3.373-22.627-9.376-6.001-5.997-9.373-14.138-9.373-22.624v-704c0-8.487 3.372-16.627 9.373-22.628s14.14-9.372 22.627-9.372h416c8.487 0 16.627-3.372 22.627-9.373s9.373-14.141 9.373-22.627c0-8.487-3.372-16.627-9.373-22.628s-14.14-9.372-22.627-9.372h-416c-25.46 0-49.879 10.114-67.882 28.118s-28.118 42.421-28.118 67.882v704z"
            ],
            "attrs":[
               {
                  "fill":"rgb(68, 56, 249)"
               },
               {
                  "fill":"rgb(68, 56, 249)"
               }
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "pencil-square"
            ]
         },
         "properties":{
            "order":53,
            "id":0,
            "name":"pencil-square",
            "prevSize":32,
            "code":59667
         },
         "setIdx":1,
         "setId":3,
         "iconIdx":0
      },
      {
         "icon":{
            "paths":[
               "M324.4 2.2c-9.4 2.8-21.8 15.8-24.6 26.2-4.6 17.8 2.4 36.4 17.6 45.8l7.6 4.8 476.2 2 15.2 7.4c18.2 9 29.4 20.599 38.197 39.2l6.4 13.4 1.007 318.001 0.998 318 4.796 7.6c2.603 4.2 8.405 10 12.8 13 6.801 4.6 10.402 5.401 21.402 5.401s14.601-0.8 21.402-5.401c4.395-2.999 10.197-8.8 12.8-13l4.796-7.6v-321c0-293.6-0.196-322-3.396-333-8.602-31.4-21.803-54.6-42.598-75.6-13.602-14-36.804-29.6-52.602-35.4-31.2-11.8-12.2-11-272.4-11.4-148-0.2-241.6 0.4-245.6 1.6z",
               "M209.999 165c-67.4 13.8-117.4 65.801-127.8 133.001-1.8 10.999-2.2 90.4-1.8 304 0.6 315-0.2 290.996 11.6 322.399 13.2 35.405 52.2 74.402 87.6 87.603 30.8 11.597 16.4 10.999 251.401 10.999s220.599 0.597 251.4-10.999c35.6-13.201 74.4-52.002 87.6-87.603 11.8-31.198 11-8.602 11-331.399 0-270.2-0.201-297-3.4-308-8.601-31.4-21.8-54.6-42.6-75.599-13.6-14.001-36.8-29.6-52.6-35.401-31-11.6-14.8-10.999-246.4-11.4-170.2-0.201-215.6 0.2-226 2.4zM654.4 249.4c18.599 8.8 30.199 20 39.2 38.199l7.4 15.2v580.4l-7.4 15.198c-9 18.202-20.6 29.406-39.2 38.204l-13.401 6.4h-420l-13.4-6.4c-18.6-8.798-30.2-20.002-39.2-38.204l-7.4-15.198v-580.2l6.4-13.4c3.401-7.4 10-17.4 14.4-22.2 8.8-9.6 27-20.2 39.4-23.2 4.6-1 93.6-1.801 213.8-1.6l206 0.4 13.401 6.4z"
            ],
            "attrs":[
               {
                  "fill":"rgb(68, 56, 249)"
               },
               {
                  "fill":"rgb(68, 56, 249)"
               }
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "copy"
            ]
         },
         "attrs":[
            {
               "fill":"rgb(68, 56, 249)"
            },
            {
               "fill":"rgb(68, 56, 249)"
            }
         ],
         "properties":{
            "order":54,
            "id":0,
            "name":"copy",
            "prevSize":32,
            "code":59668
         },
         "setIdx":2,
         "setId":2,
         "iconIdx":0
      },
      {
         "icon":{
            "paths":[
               "M473.668 87.334c-53.335 8.833-94.835 27-134.502 59.166-49.667 40.167-83.334 95.5-97.5 160.5-3.333 15.5-3.833 22-3.666 55.834 0 36 0.333 39.5 4.666 58.333 8.167 35 22.667 68.835 42.333 98.001 17.167 25.331 82.167 128.166 81.5 128.832-0.333 0.333-10 2.5-21.333 4.668-30.333 5.999-41.333 8.666-68.666 16.998-66.833 20.335-111 47.834-129.833 80.666-7.833 13.837-10.167 23.834-9.333 41.502 0.5 14.165 1.333 17.502 6.5 28.501 12.334 25.83 34.667 45.5 72.334 64.166 56.166 27.665 134 45.666 226.666 52.497 29.999 2.167 108.668 2.167 137.668 0 144.666-10.999 253.333-48.832 290.999-101.5 11.166-15.33 15.501-29.001 15.501-47.497 0-22.835-8-40.503-26.833-59.337-33.169-33.165-95.834-59.499-181.333-75.998-11.337-2.167-21.001-4.335-21.333-4.668-0.337-0.333 20.164-33.165 45.5-72.832 25.498-39.834 49.83-79.168 54.165-87.334 10.334-19.831 18.5-42.167 24.166-66.667 4.335-18.833 4.668-22.333 4.668-58.333 0.166-33.833-0.333-40.334-3.669-55.834-25.331-116.166-113.664-200.666-228.996-219-18.001-3-64.171-3.333-79.667-0.666zM548.169 139.5c90.33 14.667 163.665 85.667 183.33 177.5 3.669 17.667 4.169 71.667 0.67 87.5-4.335 19.5-13.67 45.168-22.336 61.168-8.666 16.333-196.331 311.164-197.833 311.164-0.499 0-37.5-57.83-82.5-128.499-44.833-70.498-88.333-138.667-96.333-151.002-33-50.833-44.5-85.664-44.5-136.165 0-78.667 39.666-149.5 107.5-192.166 20.833-13 53.501-25.167 79.165-29.5 17.502-3 54.502-3 72.836 0zM446.165 770.999c25.835 40.499 48.836 74.833 51.337 76.668 6.665 4.834 22.332 4.834 28.996 0 2.5-1.835 25.335-35.669 50.833-75.836 25.502-39.834 47.334-72.998 48.503-73.83 2.999-2.001 48.166 5.5 78.831 13.167 56.499 13.833 99.669 34.167 120.333 56.499 12.668 13.666 13.837 24.499 4.169 37.001-7.002 9.331-9.668 11.831-22.165 20.497-42.833 29.837-130.667 53.001-227.503 60.169-29.999 2.167-104.998 2.167-134.997 0-121.001-8.832-221.835-41.668-250.335-81.331-9-12.335-7.5-23.002 4.833-36.335 26.167-28.335 86.333-52.169 167.167-66.334 12.833-2.334 25.5-3.998 28.333-3.831 4.5 0.333 8.167 5.5 51.665 73.498z",
               "M480.333 240.333c-6.831 1.833-18.833 6.5-26.667 10.333-11.499 5.667-17.165 10-29.999 23-13 12.833-17.333 18.5-23 30-9.833 19.666-13.667 36.333-13.667 58.333s3.834 38.666 13.667 58.333c5.667 11.5 10 17.167 23 30.001 12.835 13.001 18.501 17.331 29.999 23.002 19.669 9.83 36.335 13.666 58.334 13.666s38.665-3.836 58.334-13.666c11.499-5.67 17.165-10.001 29.999-23.002 13.001-12.834 17.335-18.5 23.002-30.001 9.83-19.667 13.666-36.333 13.666-58.333s-3.836-38.667-13.666-58.333c-5.666-11.5-10.001-17.167-23.002-30-12.834-13-18.5-17.333-29.999-23-7.834-3.833-20.169-8.5-27.332-10.333-17.668-4.5-45.333-4.333-62.669 0zM539.166 293.5c18.001 7.167 34.167 23.167 41.502 41.5 5.5 13.667 5.5 40.334 0 54.167-7.334 18.167-23.334 34.167-41.668 41.502-13.666 5.5-40.333 5.5-53.999 0-18.334-7.335-34.334-23.502-41.502-41.502-5.167-13.167-6.165-35.333-2.334-47.5 8.166-24.5 22.835-40.166 46.17-49 13.999-5.333 37.167-5 51.831 0.833z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "location"
            ],
            "colorPermutations":{
               
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":50,
            "id":50,
            "name":"location",
            "prevSize":32,
            "code":59648
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":0
      },
      {
         "icon":{
            "paths":[
               "M474.001 87.667c-85.334 16.166-145.001 74.833-164.835 161.833-4.333 19-4.333 74 0 94 10.333 47.667 32.334 88.5 64.5 119.668 18.5 17.83 30.167 26.167 50.833 36.331 31.833 15.667 53.665 20.834 87.5 20.834s55.667-5.167 87.501-20.834c58.001-28.497 100.164-85.499 115.332-155.999 4.335-20 4.335-75 0-94-9.668-42.833-28.335-77.833-56-105.5-26.5-26.5-56-42.833-95.002-53.167-13.666-3.667-20.331-4.334-46.831-4.834-21.333-0.333-34.5 0.167-42.999 1.667zM552.499 154.333c71.334 21 113.335 91.833 100.501 169-9.668 57.334-44.002 103.666-91.499 123.336-66.667 27.831-140.002-3.337-175.168-74.169-31.667-64-19.334-144.167 29-187.667 18.335-16.5 43.5-29 67.832-33.667 19.836-3.667 50.667-2.333 69.333 3.167z",
               "M472 566.332c-55.167 4.668-79 8-110.167 15.834-72.333 18.001-133.333 52.668-172.666 98.167-43 49.835-66.833 109.999-73.667 186.667-4 43.166-1.833 56.499 10.833 66.001l6.167 4.834h758.999l6.17-4.834c12.663-9.502 14.831-22.835 10.833-66.001-9.003-99.998-47.501-174.332-117.001-226.334-51.166-38.332-117.833-61.666-202.833-71.164-21.167-2.5-100.335-4.501-116.668-3.17zM547.831 630.332c106.167 5.837 183.667 34.667 233.502 87.002 31.834 33.335 55.334 86.498 61.5 138.833 0.499 4.501 1.335 10.833 1.835 13.666l0.832 5.5h-667l0.833-5.5c0.5-2.833 1.333-9.165 1.833-13.666 6.167-52.335 29.667-105.498 61.5-138.833 48.666-51.166 128.166-81.335 228.834-86.835 35.665-1.997 42.999-1.997 76.331-0.166z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "account"
            ],
            "colorPermutations":{
               
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":49,
            "id":49,
            "name":"account",
            "prevSize":32,
            "code":59649
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":1
      },
      {
         "icon":{
            "paths":[
               "M502.835 121.167c-2.667 1.5-88.835 48.5-191.502 104.667-198 108.166-192.666 104.833-192.666 117 0 11.5 2.667 13.333 69 49.333 34.333 18.667 62.5 34.333 62.5 34.833s-28.167 16.166-62.667 34.999c-66.333 36.169-68.833 37.833-68.833 49.335 0 11.166 4 13.999 68.333 49.331 33.5 18.167 61.333 33.668 62 34.334s-27 16.499-61.5 35.332c-66.333 36.169-68.833 38.003-68.833 49.335 0 12.335-5 9.331 197.167 120.166 160.501 87.834 190.667 103.834 196.333 103.834 5.5 0 30.165-12.834 155.332-81.003 81.668-44.663 167.334-91.166 190.003-103.497 43.998-24 47.834-26.999 47.834-38.17 0-11.332-3.836-14.165-68.335-49.331-33.502-18.167-61.333-33.668-61.999-34.334-0.499-0.666 27.166-16.499 61.5-35.332 68.834-37.5 69.666-38.003 68.331-51.503-0.666-5.163-2.163-8.499-5.5-11.831-2.667-2.5-29.999-18.334-60.663-34.999-30.669-16.832-58.001-31.667-60.501-33.335l-4.834-2.833 61.5-33.498c33.835-18.5 63.168-35.5 65.335-37.667 7.497-7.833 5.5-23.5-3.503-29.167-2.167-1.333-87.834-48.5-190.498-104.833-114.999-63-188.834-102.667-192.499-103-3.503-0.5-7.834 0.166-10.833 1.833zM674.001 250.167c88.666 48.5 163.166 89.333 165.5 90.667 4.331 2.167 0.666 4.333-161.502 93.334l-165.999 91.166-151.166-82.999c-83.334-45.667-158-86.667-166.167-91.167l-14.667-8 15.5-8.333c8.666-4.667 83.167-45.5 165.667-90.667 82.498-45.167 150.334-82.167 150.999-82.167 0.499 0 73.335 39.666 161.835 88.166zM402.5 510.498c87.168 47.834 104 56.503 109.666 56.503 5.5 0 14.336-4.169 48.666-23.168 109.5-60.169 168.836-92.335 170.5-92.335 2.334 0 110.669 59.17 110.669 60.335 0 1.331 10.001-4.335-171.166 95.002l-158.835 86.997-96.166-52.834c-53-28.996-119.5-65.498-148-80.998-83-45.5-85.833-47.168-85.833-48 0-0.499 24.833-14.669 55.334-31.168 47.333-25.997 55.833-29.999 58.667-28.497 2 0.998 49.833 27.166 106.5 58.163zM404.167 679.834c84.332 46.165 102.5 55.501 107.833 55.501 6.502 0 21.167-7.834 198.502-105.169l20.83-11.499 56.333 31.168c55.334 30.498 56.337 31.164 51.836 33.331-2.334 1.335-77.001 42.167-165.5 90.667l-161.169 88.333-5.167-2.5c-2.833-1.331-72.666-39.33-154.998-84.497-82.5-45.001-155-84.834-161.167-88.166l-11.334-6.17 112.333-61.999 5.167 2.667c2.833 1.502 50.833 27.665 106.5 58.334z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "case"
            ],
            "colorPermutations":{
               
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":48,
            "id":48,
            "name":"case",
            "prevSize":32,
            "code":59650
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":2
      },
      {
         "icon":{
            "paths":[
               "M484.83 89.333c-5.333 2.167-12.497 6-15.834 8.333-3.499 2.333-87.665 85.833-187.332 185.5-146 146.333-181.833 183.001-185.333 189.998-16 32.337-10.667 67.669 13.833 92.335 15.334 15.168 34.833 23.168 57.167 23.168h11.334v133.333c0 90.167 0.666 136 1.833 141.999 6.333 30.332 30.833 57.835 61.167 68.335 11 3.831 11.834 3.831 92.333 3.831 79.334 0 81.167 0 85.667-3.499 2.5-1.835 6.167-5.5 8-8 3.499-4.501 3.499-6.669 4.331-115.836l0.836-111.33 5.001-8.166c6.332-10.167 19.166-18.334 31.497-19.836 4.668-0.666 28.002-0.832 51.836-0.499l43.332 0.499 8.832 4.834c8.337 4.668 13.67 10.167 18.837 19.332 1.83 3.499 2.496 24 3.166 115.332 0.832 109.001 0.832 111.168 4.331 115.669 1.835 2.5 5.5 6.165 8 8 4.501 3.499 6.336 3.499 85.666 3.499 80.503 0 81.335 0 92.335-3.831 30.336-10.5 54.835-38.003 61.167-68.335 1.169-5.999 1.835-51.831 1.835-141.999v-133.333h11.332c31.334 0 58.667-16.666 72.166-44.169 5.666-11.499 5.666-11.831 5.666-34.167 0-37.999 19.166-15.497-194.833-229.332-212.668-212.833-191.334-194.5-227.665-195.334-18.833-0.333-21.666 0-30.502 3.667zM525.999 137c9.83 4.666 358.165 353.5 361.83 361.999 3.503 8.499 3.17 15.667-0.998 24-6.165 12.834-11.332 14.669-43.499 15.667-30.17 0.832-32.333 1.502-40.333 12.335-3.503 4.497-3.503 6.332-4.335 155.665l-0.832 151.168-4.668 7.834c-2.5 4.331-7.002 9.83-10.001 11.998-11.665 9.003-15.168 9.335-78.831 9.335h-59.004v-93.333c0-61.167-0.666-96.166-1.83-102.003-6.502-31.33-31.667-58.33-64-68.497-10.999-3.503-14.669-3.669-65.835-3.669-59.665 0-62.665 0.333-83.998 11.17-21.168 10.667-40.835 36.996-45.835 60.996-1.167 5.837-1.833 40.836-1.833 102.003v93.333h-59c-63.667 0-67.167-0.333-78.833-9.335-3-2.167-7.5-7.667-10-11.998l-4.666-7.834-0.834-151.168c-0.833-149.333-0.833-151.168-4.333-155.665-8-10.833-10.167-11.503-40.333-12.335-32.167-0.998-37.333-2.833-43.5-15.667-4.167-8.333-4.5-15.501-1-24 3.5-8.333 352.001-357.166 361.665-361.999 8.503-4.167 16.337-4.167 24.836 0z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "home"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":45,
            "id":46,
            "name":"home",
            "prevSize":32,
            "code":59652
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":3
      },
      {
         "icon":{
            "paths":[
               "M406 88.668c-81.833 12.333-151.833 47.834-210.667 106.667-49.833 49.833-82.333 106.667-99.333 173.833-14.333 56.667-14.333 127.331 0 184.001 38 149.666 163.667 261.5 316.5 281.331 25.332 3.166 72.001 3.166 97.332 0 63.501-8.333 125.333-33.331 175.834-71.164l15.168-11.503 90.999 90.833c62.831 62.669 93.001 91.669 97.165 93.5 12.834 5.333 29.5 2.5 39.334-6.498 9.835-8.832 13.333-27.166 7.834-40.666-1.835-4.169-30.831-34.334-93.5-97.169l-90.833-90.999 11.499-15.168c37.833-50.5 62.835-112.333 71.168-175.834 3.166-25.331 3.166-72 0-97.331-19.831-152.833-131.665-278.5-281.335-316.5-42.999-11-103.497-14-147.165-7.334zM508.668 159.668c109.666 17.5 202.667 94.833 240.166 199.834 11.665 32.833 16.998 65.167 16.998 101.666 0 28.668-2.167 47.002-8.998 74.167-13.666 54.498-39.501 100.002-80.499 141.001-41.003 40.998-86.502 66.833-141.001 80.499-27.166 6.835-45.5 8.998-74.167 8.998-46.667 0-86.833-8.832-129.667-28.497-62-28.668-118-85.001-146.833-147.332-19.833-43.17-28.166-81.169-28.166-128.836 0-40.166 4.666-66.666 18.333-104.999 25.5-71 82-134 151.333-168.666 32.833-16.5 76.833-28.5 114.166-31.167 15.334-1 51.499 0.666 68.335 3.333z",
               "M568.41 439.599c16.009-0.124 28.958 12.774 28.924 28.817-0.038 16.034-13.043 29.137-29.047 29.261l-70.199 0.491-0.486 70.404c-0.132 15.902-13.205 28.779-29.197 28.762-15.996-0.021-28.851-12.937-28.723-28.843l0.486-69.918-69.914 0.491c-16.003 0.128-28.953-12.774-28.92-28.813 0.038-16.034 13.044-29.137 29.049-29.257l70.195-0.495 0.491-70.403c0.132-15.903 13.205-28.781 29.197-28.762 15.996 0.019 28.851 12.935 28.719 28.842l-0.486 69.919 69.914-0.495z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "magnifier"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":43,
            "id":40,
            "name":"magnifier",
            "prevSize":32,
            "code":59653
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":4
      },
      {
         "icon":{
            "paths":[
               "M491.166 88.666c-5.167 2-13.833 8.167-22.498 15.834-68.168 60.333-127.168 85.5-222.668 94.833-28.333 2.833-41 6.5-56.166 16.666-17.5 11.667-30.333 29.5-37.333 52-2.833 9-3 17.5-3 107.334 0 104.999 0.833 118.832 10 176.167 30 186.334 133.5 310.165 316.498 378.833 20.169 7.501 23.667 8.333 36.002 8.333s15.834-0.832 36.335-8.499c150.831-56.499 247.497-151.334 293.833-287.834 13.333-39.002 22.997-86.835 29.333-143.667 2.5-23.334 2.999-42.167 2.999-124.167 0-89.167-0.166-97.5-2.999-106.5-7.002-22.5-19.836-40.333-37.333-52-15.168-10.167-27.836-13.833-56.166-16.666-95.501-9.334-154.5-34.5-222.669-94.833-9.331-8.167-17.165-13.667-22.997-15.834-11.503-4.333-29.837-4.333-41.169 0zM527.667 149.167c66.999 60.5 142.831 92.334 241.835 101.333 24.832 2.167 34.833 5.667 42.667 14.5 10.999 12.5 10.667 8.333 10.667 110.333 0 97.332-0.67 110-8.337 159.165-12.83 82.5-37.666 146.167-79.164 202.001-22.835 30.835-63.334 68.501-98.334 91.499-32.166 21.001-75.669 42.5-111.334 55.002l-13.666 4.834-13.833-4.834c-21.167-7.334-56.666-23.334-77.001-34.5-122.833-67.665-190.5-168.666-212.333-316.497-7-48.337-7.667-61.001-7.667-156.669v-92.5l3.834-7.5c9.167-17.5 18.167-22 49.5-24.833 100.167-9.167 178.166-42.333 244.999-104.166 5.5-5 10.999-9.167 12.335-9.333 1.165 0 8.333 5.5 15.834 12.166z",
               "M479.501 301.167c-76.167 12.167-139.834 63.667-167.334 135.834-17.667 45.833-17.667 104.166 0 149.999 31.833 83.166 111.333 138.334 199.833 138.334 67.665 0 131.166-32.166 171.665-86.835 14.835-19.831 28.335-47.663 34.334-70.665 11.337-42.5 9.003-91.499-6.165-130.833-21.666-56.834-68.002-103.167-124.834-124.834-31.501-12.167-73.664-16.334-107.499-11zM550.165 355.167c58.167 14.667 104.333 60.833 118.502 118.668 21.167 85.833-30.835 171.499-118.336 194.999-20.331 5.5-56.333 5.5-76.663 0-59.335-15.834-102.502-58.999-118.668-118.502-5.333-20.164-5.333-56.166 0.167-76.663 8.167-30.502 22.833-55.668 44.666-76.835 25.667-25 50.501-37.333 92.169-45.5 9.498-1.833 44.497 0.5 58.163 3.833z",
               "M579.499 440.499c-1.83 1.003-26.167 24.666-54.165 52.501l-50.833 50.667-14.165-14.336c-16.166-16.333-20.501-18.999-30.003-18.999-13.499 0-23.499 8.166-25.999 21.167-2.167 11.503 0.166 15.002 27.5 42.667 14.332 14.502 27.998 27.503 30.498 28.834 5.837 2.999 18.5 2.999 24.333 0 2.5-1.331 31.667-29.666 64.836-63.002 59.665-59.831 65.498-66.662 65.498-76.663-0.166-6.835-6.332-17.835-11.998-21.333-6.165-3.669-19.836-4.501-25.502-1.502z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "protector"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":44,
            "id":39,
            "name":"protector",
            "prevSize":32,
            "code":59654
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":5
      },
      {
         "icon":{
            "paths":[
               "M177.333 87.171c-43.167 5.667-79.666 38.333-89.333 79.834-2.333 9.5-2.667 51.166-2.667 345 0 370.833-0.833 343.834 11.334 368.333 8.333 17.169 28 36.834 45.333 45.5 25.667 12.668 13.833 12.002 205 12.002 133.999 0 172.168-0.499 176.832-2.167 6.835-2.334 15.501-10.334 19.503-17.668 1.664-3.332 2.667-9.165 2.833-16 0-14.165-5.666-24.499-17.169-31.164l-7.834-4.668-169.999-0.832c-155.833-0.836-170.5-1.003-175.167-3.669-7.333-3.998-15.167-13.5-17.167-20.834-2.5-8.832-2.5-648.832 0-657.665 2-7.333 9.833-16.833 17.167-20.833 4.667-2.667 19.334-2.833 175.167-3.667l169.999-0.833 7.834-4.666c11.503-6.667 17.169-17 17.169-31.167-0.166-11.834-2.5-17.833-10.334-25.667-10.5-10.833 0.333-10.167-182.167-10.333-91.167-0.167-170.667 0.333-176.334 1.167z",
               "M672.832 266.836c-3.665 1.667-8.499 4.834-10.667 6.833-9.664 9.333-12.83 28-6.997 40.833 1.997 4.667 26.999 30.5 80.832 83.667l77.833 77.167-419.333 0.832-6.667 3.669c-12.833 6.831-19.167 17.498-19.167 32.166 0 14.665 6.333 25.331 19.167 32.166l6.667 3.665 419.333 0.832-77.833 77.167c-53.833 53.167-78.835 79.002-80.832 83.669-5.833 12.834-2.667 31.501 6.997 40.832 10.334 9.835 27.836 12.668 41.169 6.669 10.334-4.668 229.001-221.001 232.666-230.17 3.332-8.333 3.332-21.333 0-29.666-3.665-9.165-222.332-225.499-232.666-230.166-9.003-4.167-21.833-4.167-30.502-0.167z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "logout"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":46,
            "id":38,
            "name":"logout",
            "prevSize":32,
            "code":59655
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":6
      },
      {
         "icon":{
            "paths":[
               "M461.999 87.511c-18.001 5.667-34.833 18.167-43.999 32.333-8 12.666-11.834 25.833-13 44.833l-1 17-6 2c-3.333 1-14.833 5.5-25.667 10.167l-19.5 8.334-11.5-10.667c-27.167-25.167-61.5-31-92.667-15.667-10 5-16 10.167-40.333 34.667-24 24.166-29.5 30.667-33.667 39.667-14.667 31.166-8.667 65 16.167 91.833l10.667 11.667-5.833 12.833c-3.167 7-7.834 18.5-10.333 25.5l-4.5 12.667-16.833 1c-35.667 2-58.833 17-73.167 47.165l-5.5 11.503v94.997l5.5 11.503c14.333 30.165 37.5 45.163 73.167 47.164l16.833 1.003 4.5 12.663c2.5 7.002 7.167 18.5 10.333 25.502l5.833 12.834-10.667 11.665c-18.833 20.335-26.833 43.836-23.167 68.169 3.5 23.164 8.333 30.831 40.666 63.33 32.333 32.503 41.667 38.669 63.834 42.001 26 4.002 49.5-4.164 71-24.666l9.5-8.998 19.667 8.333c10.833 4.663 22.333 9.165 25.667 10.163l6 2.001 1 17.003c2 35.665 16.833 58.833 47.168 73.165l11.499 5.5h95.002l11.499-5.5c30.165-14.165 45.167-37.5 47.168-72.998l0.998-16.836 12.668-4.663c6.997-2.5 18.5-7.168 25.664-10.5l12.834-5.837 9.668 9.169c21.5 20.501 45.167 28.668 71.33 24.666 21.837-3.332 31.334-9.664 63.501-42.001 24-24.166 29.5-30.665 33.668-39.663 14.498-31.168 8.666-65.169-16.166-91.836l-10.667-11.499 8.333-19.503c4.668-10.833 9.331-22.332 10.5-25.664l2.001-5.999 16.832-1.003c35.499-2.001 58.833-16.998 72.998-47.164l5.5-11.503v-94.997l-5.5-11.503c-14.165-30.166-37.5-45.166-72.998-47.165l-16.832-1-2.001-6c-1.169-3.333-5.833-14.833-10.5-25.667l-8.333-19.5 10.667-11.5c25.165-27.167 30.997-61.5 15.667-92.667-5.001-10-10.167-16-34.667-40.333-24.166-24-30.669-29.5-39.667-33.667-31.168-14.667-65.003-8.667-91.836 16.167l-11.665 10.667-12.834-5.667c-6.997-3.333-18.667-8-25.664-10.667l-13.001-4.833v-10c0-31.834-12.169-57-34.999-72.667-17.335-11.833-24.337-13.167-72.166-13-29.001 0-44.002 0.667-48.67 2.167zM549.999 139.177c3.669 1.833 8.499 6.167 10.833 9.833 4.335 6.5 4.501 8 5.333 34.333 1.169 37.667 0.166 36.333 35.836 47.667 10.999 3.5 30.165 11.666 42.5 17.833 21.333 10.833 22.997 11.5 32 10.833l9.498-0.5 19.166-18.667c21.5-20.833 27.004-23.666 39.834-20.333 5.837 1.667 11.17 6.167 31.501 26.333 20.169 20.333 24.666 25.667 26.334 31.5 3.332 12.833 0.499 18.333-20.335 39.833l-18.667 19.167-0.499 9.5c-0.666 9 0 10.667 10.833 32 6.17 12.333 14.336 31.5 17.835 42.5 11.332 35.668 10.001 34.665 47.667 35.834 26.334 0.832 27.831 0.998 34.334 5.333 11.831 7.834 13.001 12.497 13.001 49.664s-1.169 41.835-13.001 49.668c-6.502 4.335-8 4.501-34.334 5.333-37.666 1.165-36.335 0.166-47.667 35.831-3.499 11.004-11.665 30.17-17.835 42.5-10.833 21.333-11.499 23.002-10.833 32l0.499 9.502 18.667 19.166c20.834 21.5 23.667 26.999 20.335 39.667-1.668 5.999-6.165 11.332-26.334 31.667-20.331 20.164-25.664 24.666-31.501 26.334-12.83 3.332-18.334 0.499-39.834-20.335l-19.166-18.667-9.498-0.499c-9.003-0.666-10.667 0-32 10.833-12.335 6.165-31.501 14.332-42.5 17.835-35.669 11.332-34.667 9.997-35.836 47.667-0.832 26.33-0.998 27.831-5.333 34.33-7.834 11.836-12.497 13.001-49.664 13.001s-41.835-1.165-49.668-13.001c-4.335-6.498-4.501-8-5.333-34.33-1.165-37.67-0.166-36.335-35.833-47.667-11-3.503-30.167-11.669-42.5-17.835-21.333-10.833-23-11.499-32-10.833l-9.5 0.499-19.167 18.667c-21.5 20.834-27 23.667-39.833 20.335-5.833-1.668-11.167-6.17-31.5-26.334-20.167-20.335-24.667-25.668-26.333-31.667-3.333-12.668-0.5-18.167 20.333-39.667l18.667-19.166 0.5-9.502c0.667-8.998 0-10.667-10.833-32-6.167-12.331-14.333-31.497-17.833-42.5-11.334-35.665-10-34.667-47.667-35.831-26.333-0.832-27.833-0.998-34.333-5.333-11.833-7.834-13-12.501-13-49.668s1.167-41.83 13-49.664c6.5-4.335 8-4.501 34.333-5.333 37.667-1.169 36.333-0.166 47.667-35.834 3.5-11 11.667-30.167 17.833-42.5 10.833-21.333 11.5-23 10.833-32l-0.5-9.5-18.667-19.167c-20.833-21.5-23.666-27-20.333-39.833 1.667-5.833 6.167-11.167 26.333-31.5 27.333-27.334 32-30 45.167-26.333 5.5 1.5 11 5.833 26.167 20.333 19 18.333 19.167 18.5 28.167 19.334 8.667 0.666 10.333 0 32.833-11.167 13.167-6.5 33.167-14.833 44.5-18.5 11.501-3.667 22.5-7.834 24.335-9 7.33-4.833 9.165-12.333 9.165-36.333 0-26.167 1.502-32.834 9.165-40.5 7.834-7.834 15.002-9 49.169-8.667 24.666 0.333 30.165 0.833 35.499 3.5z",
               "M486.498 327.011c-25.498 3.333-59.332 16-79.665 30-14.5 9.833-30.167 24.5-41.5 38.5-13.167 16.5-29.167 47.668-34.167 67.167-8.167 31.667-8.167 66.999 0 98.334 4 14.831 16.666 42.999 25.167 55.168 33 48.166 85.668 77.999 144.002 81.664 59.665 3.836 118.498-22.332 156.663-69.666 13.167-16.499 29.167-47.667 34.167-67.166 8.166-31.667 8.166-66.667 0-98.334-5.001-19.499-21.001-50.667-34.167-67.167-18.833-23.334-38.665-38.833-66.33-52-32.337-15.5-68.501-21.167-104.171-16.5zM543.667 381.177c48.499 13 83.998 48.165 97.835 97.001 5.333 18.334 5.163 49.165 0 67.665-13.5 47.168-49.169 82.833-96.503 96.333-18.5 5.333-49.165 5.333-67.831 0-47.667-13.666-82.667-48.666-96.334-96.333-4.833-17.165-5.167-49.165-0.666-65.664 15.166-55.169 57.499-93.169 113.499-102.335 9.335-1.333 39.834 0.5 50.001 3.333z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "settings"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":47,
            "id":37,
            "name":"settings",
            "prevSize":32,
            "code":59656
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":7
      },
      {
         "icon":{
            "paths":[
               "M606.874 270.333v150c0 17.717-5.291 44.409 8.614 57.977 13.158 12.838 42.492 7.023 59.473 7.023h114.586c14.178 0 36.45-4.258 49.673 1.003 9.818 3.908 17.724 19.213 23.983 27.332 5.504 7.142 13.406 14.716 16.478 23.33 4.39 12.331 1.207 30.332 1.207 43.337v93.333c-11.767 0-35.93 4.642-46.037-1.715-6.831-4.292-8.832-18.057-12.608-24.951-7.394-13.513-18.492-26.035-31.031-34.931-57.429-40.725-156.437-15.151-167.731 61.598h-157.769c-11.115-75.537-110.827-103.45-167.729-61.79-12.57 9.203-23.547 21.44-31.035 35.123-3.63 6.63-6.278 20.83-12.646 24.951-5.367 3.473-14.992 1.715-21.086 1.715-16.963 0-44.788-5.299-59.76 3.712-18.705 11.26-16.477 40.401 3.297 49.007 21.361 9.297 58.205 2.278 81.373 2.278 5.068 50.761 63.704 81.954 109.606 79.936 28.921-1.271 58.551-15.633 76.71-38.272 7.287-9.079 16.832-39.561 27.985-41.417 32.939-5.474 71.125-0.247 104.555-0.247 11.891 0 31.868-3.866 42.803 1.007 6.925 3.089 9.114 16.077 12.514 22.327 7.351 13.508 17.015 25.583 29.376 34.739 55.979 41.459 157.939 19.75 169.391-58.074h66.428c10.807 0 22.345 0.73 30.677-7.552 8.883-8.836 7.518-20.962 7.518-32.448v-73.331c0-29.38 7.369-70.234-1.075-98.334-6.775-22.537-31.923-44.796-45.999-63.334-16.956-22.34-28.062-49.973-40.529-75l-34.876-70c-5.508-11.052-10.359-26.253-20.493-33.914-11.324-8.558-28.1-6.086-41.365-6.086h-89.677c0-17.75 4.463-41.368-14.946-50.713-9.702-4.67-22.758-2.621-33.212-2.621h-405.212c-12.028 0-25.916-2.022-36.38 5.222-17.975 12.444-13.632 43.574 8.148 48.889 13.816 3.372 30.669 0.888 44.839 0.888h381.962zM150.18 326.215c-24.89 5.775-30.060 42.767-4.976 52.46 16.102 6.223 40.976 1.658 58.118 1.658h129.534c18.017 0 48.488 5.84 64.761-2.429 23.215-11.793 16.63-47.505-8.297-52.023-15.778-2.858-33.804-0.548-49.821-0.548h-96.32c-29.021 0-64.731-5.676-92.999 0.882z",
               "M661.675 325.333v104.998h149.461l-37.786-76.665-16.004-27.328-29.244-1.005h-66.428z",
               "M103.68 432.93c-24.325 6.417-24.037 43.349-1.661 52.156 16.222 6.387 40.862 1.916 58.124 1.916h131.195c17.748 0 47.33 5.636 63.1-3.486 19.951-11.537 17.414-46.285-6.636-50.948-16.677-3.234-36.172-0.567-53.142-0.567h-104.624c-26.486 0-60.744-5.824-86.356 0.93zM150.18 537.882c-25.036 5.807-29.854 42.313-4.982 52.437 10.878 4.425 26.625 1.681 38.196 1.681h71.41c10.783 0 24.66 2.287 34.868-1.66 23.171-8.951 21.405-44.087-1.654-51.917-12.679-4.305-29.908-1.421-43.178-1.421-29.529 0-65.898-5.794-94.66 0.879z",
               "M356.106 647.74c-66.722 9.745-56.822 113.826 9.964 104.917 67.956-9.062 57.306-114.748-9.964-104.917zM723.119 647.718c-66.611 8.806-59.209 111.927 8.303 105.169 68.092-6.814 58.914-114.052-8.303-105.169z"
            ],
            "isMulticolor":true,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "shipping-van"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  {
                     "f":1
                  },
                  {
                     "f":4
                  },
                  {
                     "f":1
                  },
                  {
                     "f":4
                  }
               ]
            }
         },
         "attrs":[
            {
               "fill":"rgb(68, 56, 249)"
            },
            {
               "fill":"rgb(255, 255, 255)"
            },
            {
               "fill":"rgb(68, 56, 249)"
            },
            {
               "fill":"rgb(255, 255, 255)"
            }
         ],
         "properties":{
            "order":51,
            "id":36,
            "name":"shipping-van",
            "prevSize":32,
            "code":59657,
            "codes":[
               59657,
               59658,
               59659,
               59660
            ]
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":8
      },
      {
         "icon":{
            "paths":[
               "M298.668 469.328h85.333v85.334h-85.333v-85.334zM298.668 639.995h85.333v85.336h-85.333v-85.336zM469.334 469.328h85.334v85.334h-85.334v-85.334zM469.334 639.995h85.334v85.336h-85.334v-85.336zM640 469.328h85.338v85.334h-85.338v-85.334zM640 639.995h85.338v85.336h-85.338v-85.336z",
               "M213.333 938.662h597.336c47.059 0 85.331-38.272 85.331-85.331v-597.336c0-47.061-38.272-85.333-85.331-85.333h-85.338v-85.334h-85.331v85.334h-256v-85.334h-85.333v85.334h-85.334c-47.061 0-85.333 38.272-85.333 85.333v597.336c0 47.059 38.272 85.331 85.333 85.331zM810.669 341.328l0.038 512.003h-597.374v-512.003h597.336z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "calendar"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":39,
            "id":34,
            "name":"calendar",
            "prevSize":32,
            "code":59662
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":9
      },
      {
         "icon":{
            "paths":[
               "M853.338 170.672h-682.668c-47.062 0-85.334 38.272-85.334 85.333v512.001c0 47.059 38.272 85.331 85.334 85.331h682.668c47.059 0 85.331-38.272 85.331-85.331v-512.001c0-47.061-38.272-85.333-85.331-85.333zM170.669 256.005h682.668v85.333h-682.668v-85.333zM170.669 768.006v-256.001h682.707l0.045 256.001h-682.751z",
               "M256 597.328h256v85.334h-256v-85.334z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "credit-card"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":40,
            "id":33,
            "name":"credit-card",
            "prevSize":32,
            "code":59664
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":10
      },
      {
         "icon":{
            "paths":[
               "M512.001 85.328c-117.632 0-213.333 95.702-213.333 213.334v85.333h-42.667c-47.061 0-85.333 38.272-85.333 85.333v384.003c0 47.059 38.272 85.331 85.333 85.331h511.999c47.066 0 85.338-38.272 85.338-85.331v-384.003c0-47.061-38.272-85.333-85.338-85.333h-42.662v-85.333c0-117.632-95.704-213.334-213.336-213.334zM384.001 298.662c0-70.571 57.429-128 128-128s127.999 57.429 127.999 128v85.333h-255.999v-85.333zM768.090 853.331h-213.421v-97.197c25.386-14.803 42.666-42.029 42.666-73.472 0-47.062-38.272-85.334-85.333-85.334s-85.333 38.272-85.333 85.334c0 31.405 17.28 58.669 42.666 73.472v97.197h-213.333v-384.003h511.999l0.090 384.003z"
            ],
            "attrs":[
               
            ],
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "lock"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":41,
            "id":32,
            "name":"lock",
            "prevSize":32,
            "code":59665
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":11
      },
      {
         "icon":{
            "paths":[
               "M567.098 0l-567.098 506.213 578.79 517.787 61.21-65.312-505.723-452.394 494.031-440.98-61.21-65.314z"
            ],
            "attrs":[
               
            ],
            "width":640,
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "left-arrow"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":36,
            "id":30,
            "name":"left-arrow",
            "prevSize":32,
            "code":59661
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":12
      },
      {
         "icon":{
            "paths":[
               "M72.902 0l567.098 506.213-578.79 517.787-61.21-65.312 505.723-452.394-494.031-440.98 61.21-65.314z"
            ],
            "attrs":[
               
            ],
            "width":640,
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "right-arrow"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":37,
            "id":29,
            "name":"right-arrow",
            "prevSize":32,
            "code":59663
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":13
      },
      {
         "icon":{
            "paths":[
               "M-0.038 512c0 282.77 229.566 512 512.751 512 283.057-0.303 512.445-229.356 512.748-512 0-282.77-229.565-512-512.748-512-283.186 0-512.751 229.23-512.751 512zM35.148 512.035c0-263.367 213.814-476.868 477.565-476.868v-0.158c263.7 0.282 477.373 213.714 477.57 477.026 0 263.369-213.815 476.869-477.57 476.869-263.751 0-477.565-213.5-477.565-476.869z",
               "M512.709 1023.839c-124.683 0.020-245.085-45.395-338.613-127.724l-12.937-11.343 11.083-13.154c44.522-45.651 101.38-77.383 163.646-91.333 17.629-5.49 33.94-14.541 47.922-26.585 8.778-7.865 14.896-18.255 17.511-29.735 1.264-7.129 0.949-44.505 0-77.706-22.155-28.109-38.717-60.195-48.789-94.523-17.758-11.043-29.933-29.152-33.447-49.743-5.005-18.412-2.731-38.042 6.35-54.823-19.169-112.405-6.745-195.979 36.997-248.125 39.535-43.163 96.705-65.849 155.125-61.558h6.156c57.309 0 70.522 12.052 82.826 28.908 2.020 3.082 4.466 5.866 7.259 8.271 29.83-0.842 58.207 12.848 76.083 36.706 34.355 45.489 38.498 132.529 11.52 234.419 10.492 17.373 12.91 38.443 6.624 57.738-4.368 21.748-18.44 40.314-38.219 50.412-8.196 33.855-23.3 65.658-44.375 93.42v73.216c1.725 13.221 8.779 25.171 19.527 33.083l7.495 7.404c12.702 8.625 26.459 15.588 40.94 20.716 60.841 14.009 116.319 45.308 159.74 90.112l11.083 13.154-12.938 11.343c-93.554 82.227-213.937 127.543-338.57 127.449z"
            ],
            "attrs":[
               
            ],
            "width":1063,
            "isMulticolor":false,
            "isMulticolor2":false,
            "grid":0,
            "tags":[
               "user-o"
            ],
            "colorPermutations":{
               "151151150119219219212162162161255255255168562491":[
                  
               ]
            }
         },
         "attrs":[
            
         ],
         "properties":{
            "order":12,
            "id":15,
            "name":"user-o",
            "prevSize":32,
            "code":59651
         },
         "setIdx":3,
         "setId":1,
         "iconIdx":14
      }
   ],
   "height":1024,
   "metadata":{
      "name":"icomoon"
   },
   "preferences":{
      "showGlyphs":true,
      "showCodes":true,
      "showQuickUse":true,
      "showQuickUse2":true,
      "showSVGs":true,
      "fontPref":{
         "prefix":"icon-",
         "metadata":{
            "fontFamily":"icomoon"
         },
         "metrics":{
            "emSize":1024,
            "baseline":6.25,
            "whitespace":50
         },
         "embed":false
      },
      "imagePref":{
         "prefix":"icon-",
         "png":true,
         "useClassSelector":true,
         "color":0,
         "bgColor":16777215
      },
      "historySize":50,
      "gridSize":16,
      "showGrid":true
   }
}